import { $http } from '@/utils';
import { MD5 } from 'crypto-js';

/**
 * @namespace Service
 * @class News
 * @exports Service/Cms/News
 * @description API News Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class News {
	/**
	 * @static @name list
	 * @description Get all news as a list that can be manipulated through post body properties
	 * @returns {Object} Promise a http response
	 */
	static list(payload, domain, cache = true) {
		const cacheHash = MD5(JSON.stringify({ payload, domain })).toString();
		return $http.post(
			'cms/news/list',
			{ ...payload, cacheHash },
			{
				cache,
				cachePath: `table-cms-news-${cacheHash}`
			}
		);
	}

	/**
	 * @static @name get
	 * @description Get a single news item by id
	 * @returns {Object} Promise a http response
	 */
	static get(id) {
		return $http.get(`cms/news/${id}`);
	}
}
